import useMapOrdersSettingsQuery from "../queries/mapOrders/useMapOrdersSettings";
import useSystemTrackerHook from "./useSystemTrackerHook";

const useEnabledFormules = () => {
  const {
    systemTrackerQuery: { data },
  } = useSystemTrackerHook();
  const { data: mapOrdersSettings } = useMapOrdersSettingsQuery();
  const isEnabled =
    (data?.use_formulas || mapOrdersSettings?.merge_formulas) ?? false;
  return isEnabled;
};

export default useEnabledFormules;
